import { render, staticRenderFns } from "./UsersDeleteDataRequests.vue?vue&type=template&id=1e8e816b&scoped=true"
import script from "./UsersDeleteDataRequests.vue?vue&type=script&lang=js"
export * from "./UsersDeleteDataRequests.vue?vue&type=script&lang=js"
import style0 from "./UsersDeleteDataRequests.vue?vue&type=style&index=0&id=1e8e816b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8e816b",
  null
  
)

export default component.exports